//
// AbstractRangeConstraintType.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractConstraintType";

var AbstractRangeConstraintType = createModule("BIRD::AbstractRangeConstraintType", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractConstraintType"], EventDispatcher, [
    ,
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default AbstractRangeConstraintType;
